import * as React from 'react'
// components
import Card from 'components/PageComponents/DataHub/Main/components/Hub/components/Card'
// views
import { Wrapper } from './views'
// types
import { IPowerBiReport } from 'types/graphql'

interface Props {
  reports: IPowerBiReport[]
  standard?: boolean
}

const Hub: React.FC<Props> = ({ reports, standard }) => {
  return (
    <Wrapper>
      {reports.map((report) => (
        <Card key={report.id} report={report} standard={standard} />
      ))}
    </Wrapper>
  )
}

export default Hub
